import { Helmet } from 'react-helmet-async';
import { string } from 'prop-types';
import { useRouteLoaderData } from 'react-router-dom';

/**
 * Component for setting the SEO title of a page.
 *
 * @param {string} props.pageTitle - The title of the page to be displayed in the browser tab.
 * @returns {JSX.Element} The Helmet component with the page title.
 */
const PageSEO = ({ pageTitle }) => {
	const { siteTitle } = useRouteLoaderData('identity');

	if (!siteTitle) {
		return (
			<Helmet>
				<title>{pageTitle}</title>
			</Helmet>
		);
	}

	const title =
		typeof siteTitle === 'function'
			? siteTitle(pageTitle)
			: pageTitle.concat(siteTitle);

	return (
		<Helmet>
			<title>{title}</title>
		</Helmet>
	);
};

PageSEO.propTypes = {
	pageTitle: string.isRequired,
};
export default PageSEO;
